import { useState } from 'react'

import { uniqBy } from 'lodash'

import { Option } from 'modules/expenses/components/FormFieldEditModal/Options'
import {
  CustomizationField,
  fieldOptions,
  useExpensesCustomization,
} from 'modules/expenses/hooks/useExpensesCustomization'
import { FieldOptions } from 'modules/expenses/lib/types'

const usePaymentMethodOptions = (field: CustomizationField, payment?: string): FieldOptions => {
  const [options, setOptions] = useState<Option[]>(() =>
    fieldOptions(field).filter((option) => !option.hidden)
  )
  const optionsByPayment = options.filter(({ parent_id }) => parent_id === payment)

  const { fields } = useExpensesCustomization()
  const payments = fieldOptions('expense', 'payment', fields ?? [])

  const valid = payments.every((payment) =>
    options.find(({ parent_id }) => parent_id === payment.value)
  )

  const factorialCard = fieldOptions(field).find(({ id }) => id === 'factorial_card')
  const normalized = uniqBy(options, (option) => [option.parent_id, option.label].join())

  const setOptionsByPayment = (optionsByPayment: Option[]) => {
    const paymentOptions = optionsByPayment.map((option) => ({
      ...option,
      parent_id: payment,
    }))
    const otherOptions = options.filter(({ parent_id }) => parent_id !== payment)

    setOptions([...paymentOptions, ...otherOptions])
  }

  return {
    value: optionsByPayment,
    set: setOptionsByPayment,
    normalized: factorialCard ? [...normalized, factorialCard] : normalized,
    valid,
  }
}

export default usePaymentMethodOptions
